

























import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import moment from "moment-timezone";
import _ from "lodash";
import * as transferScheduleUtility from "@/employee/Utilities/TransferScheduleUtility";
import { useHsabExpenseFormStore } from "@/employee/store/hsabExpenseForm";
import HsabExpenseReimbursementStatusPill from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseReimbursementStatusPill.vue";
import { HsabExpenseRelationshipResponse, HsabExpenseResponse, RelationshipType, TransferSchedule } from "@/shared/types";

@Component({
  components: { HsabExpenseReimbursementStatusPill }
})
export default class AccountHolderExpenseRelationships extends Vue {
  hsabExpenseFormStore = useHsabExpenseFormStore();

  @Prop()
  expense: HsabExpenseResponse;

  @Prop()
  relationships: HsabExpenseRelationshipResponse[];

  get groupedRelationships (): Record<string, HsabExpenseRelationshipResponse[]> {
    if (this.relationships === undefined) {
      return {};
    }
    return _.groupBy(this.relationships, r => r.relationshipType);
  }
  getDisplayForRelationshipTypeString (t: string): string {
    switch (t) {
      case RelationshipType.Unknown:
      case RelationshipType.ClonedDueToWexRequirements:
        return "";
      case RelationshipType.ClonedFromRecurringTemplate:
        return "Submitted Expenses";
      default:
        return "";
    }
  }
  isRelationshipsObjectEmpty () {
    return _.isEmpty(this.relationships);
  }
  getDateDisplay (str) {
    return moment(str).format("MMM Do, YYYY");
  }
}

